module.exports = __webpack_public_path__ + "static/media/ee.03c3d564.svg";